import React, { Component } from 'react'
import logoreg from "../abc.png"
export class Guidlines extends Component {

    NextForm = () => {
        // alert("hi")
        this.props.history.push(`./FormProfile`);
    }

    render() {
        return (
            <>

                <div className="container-fluid">
                    <span className="align-middle d-flex justify-content-center">
                        <img src={logoreg} alt="logo" style={{ width: "300px" }}></img></span>
                    <div className="row justify-content-md-center my-2 ">
                        <div className="col-md-8 border  border-5 p-3 mb-2 ">
                            <h4 className="text-primary">अति महत्वाची सूचना </h4>
                            <p>कृपया मराठीत फॉर्म भरतांना त्या शब्दाचे मराठी उच्चारानुसार स्पेलिंग बनवल्यास आपले मराठीत शब्द बरोबर
                                येतात त्यानंतर योग्य शब्द सिलेक्ट करावा. याची काळजी घ्यावी.</p>

                            <p> उदा.<br />
                                फैजपुर असे टाईप करण्यासाठी faijpur असे स्पेलिंग  टाईप करावे लागते <br />
                                काही अजून उदाहरण सोबत दिले आहे समजून घ्यावे <br />
                                एम :- em<br />
                                एन :- en<br />
                                भालोद :- bhaalod<br />
                                मोताळा :- motalaa<br />
                                जळगाव :- jalgav<br />
                                कॉलनी :- kolani किंवा colani <br />
                                सांभाळणारी :- saambhaalanaari <br />
                                अशा प्रकारे उच्चार नुसार स्पेलिंग बनवावे लागते.</p>

                            <p>
                                काही गडबड झाल्यास आमच्याकडुन स्वताः हुन हातोहात माहिती पूर्ण करून एकाच वेळेस सर्व चुका दुरुस्त करून घ्याव्या.
                                <br />

                                ज्यांना फॉर्म भरायला कुठेही अडचण आली तर लगेच ऑफिस कळवावे त्यापुढील फॉर्म गरज पडल्यास आम्ही भरून देऊ.<br />
                                त्यासाठी आम्हाला आमच्या व्हाट्स अँप वर आपला फोटो, बायो डेटा चा फोटो, ओळखपत्र चा फोटो आणि फी भरल्याचा
                                स्क्रीन शॉट पाठवावा.<br />आणि एक कॉल करून कळवावे.</p>

                        </div>
                        <div className="col-md-12 text-center">

                            <button class="btn btn-primary" type="button" onClick={() => this.NextForm()}>Click Here To Complete Your Form</button>

                        </div>
                    </div>

                </div>
            </>
        )
    }
}

export default Guidlines
